import { client } from '../http';

export default {
  async saveActivationSurveyAnswers(answers) {
    return client.post('/api/survey/activation', answers);
  },
};
